<template>
  <v-container fluid class="saleschannel-list mt-3">
    <v-row class="ma-0">
      <v-card width="100%" class="ma-1">
        <v-card-text>
          <v-row no-gutters>
            <v-col cols="12" md="6" class="d-flex flex-start justify-md-start">
              <v-btn to="/saleschannel/add" color="success" class="button-shadow mr-3">
                <v-icon class="mr-2">mdi-plus</v-icon>
                Add
              </v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-card class="ma-1">
          <v-card-text>
            <v-data-table
              :loading="isReceiving || isDeleting"
              loading-text="Loading... Please wait"
              class="saleschannels-table"
              show-select
              single-select
              item-key="_id"
              sort-by="saleschannelname"
              :footer-props="footer"
              :headers="header_channels"
              :items="saleschannels"

              :items-per-page="itemPerPage">
              <template v-slot:top>
                <v-dialog
                  v-model="isDelete"
                  width="500"
                >
                  <v-card>
                    <v-card-title>
                      Delete this Sales Channel?
                    </v-card-title>

                    <v-card-text>
                      {{ delete_channel.channelname }}
                    </v-card-text>

                    <v-divider></v-divider>

                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="primary" outlined @click="isDelete = false">Cancel</v-btn>
                      <v-btn color="secondary" class="button-shadow" @click="deleteItem(delete_channel)">Delete</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </template>
              <template v-slot:item.image="{ item }">
                <v-avatar v-if="item.channelimage" size="35">
                  <img v-bind:src="item.channelimage" alt="">
                </v-avatar>
                <v-avatar
                  v-else
                  color="warning"
                  size="35">
                  <span class="white--text headline">{{ item.channelname[0].toUpperCase() }}</span>
                </v-avatar>
              </template>
              <template v-slot:item.channelname="{ item }">
                <p class="two-line"><a class="primaryConst--text">{{ item.channelname }}</a></p>
                <p class="two-line">{{ item.channelinfo }}</p>
              </template>
              <template v-slot:item.channelstatus="{ item }">
                <v-chip
                  :color="
                  item.channelstatus=='New' ? 'primaryConst white--text' : 
                  item.channelstatus=='Active' ? 'success white--text' : 
                  item.channelstatus=='Inactive' ? 'greyConst white--text' : 
                  'secondaryConst white--text'"
                  small>
                  {{ item.channelstatus }}
                </v-chip>
              </template>
              <template v-slot:item.createdAt="{ item }">
                {{ new Date(item.createdAt).toLocaleString("en-US", { year: 'numeric', month: 'numeric', day: 'numeric' }) }}
              </template>
              <template v-slot:item.actions="{ item }">
                <v-btn icon color="primary" @click="editItem(item)">
                  <v-icon>mdi-pencil-outline</v-icon>
                </v-btn>
                <v-btn icon color="primary" @click="deleteDialog(item)">
                  <v-icon>mdi-delete-outline</v-icon>
                </v-btn>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import config from "../../../config"
import { mapState, mapActions } from 'vuex'

export default {
  name: 'saleschannelList',
  data() {
    return {
      config,
      snackbar: null,
      isDelete: false,
      delete_channel: {},
      header_channels: [
        { text: 'Image', value: 'image', sortable: false, width: "10%"  },
        { text: 'Type', value: 'channeltype', width: "10%"  },
        { text: 'Code', value: 'channelcode' },
        { text: 'Name', value: 'channelname' },
        { text: 'Status', value: 'channelstatus', width: "10%"  },
        { text: 'Create', value: 'createdAt', width: "10%"  },
        { text: 'Actions', value: 'actions', sortable: false, width: "10%" },
      ],
      footer: {'items-per-page-options': [100, 500, 1000, 5000]},
      itemPerPage: 500,
      selected: [],
    }
  },
  computed: {
    ...mapState('SalesChannel', ['saleschannels', 'isReceiving', 'isDeleting', 'idToDelete', 'saleschannelsMessage', 'isUpdating']),
  },
  methods: {
    ...mapActions('SalesChannel', ["getSalesChannelsRequest","deleteSalesChannelRequest","updateSalesChannelRequest","insertSalesChannelRequest"]),
    editItem(item) {
      this.$router.push({ name: 'SalesChannelEdit', params: item })
    },
    deleteItem(item) {
      this.deleteSalesChannelRequest(item);
      this.isDelete = false;
    },
    deleteDialog(item) {
      this.isDelete = true;
      this.delete_channel = {
        _id: item._id,
        saleschannelname: item.channelname,
      }
    },
  },
  async created () {
    await this.getSalesChannelsRequest()
  },
}
</script>

<style src="./List.scss" lang="scss"></style>
